import React from 'react'
import jiminsproduction from '../image/jiminsproduction.webp'
import { NavLink } from 'react-router-dom'
import manuments from '../image/manuments.jpeg'

const Varietydetails = () => {
  return (
    <div>
        <div className="bg-gradient-to-r from-pink-200 to-fuchsia-100 overflow-hidden">
        <div class="grid lg:grid-cols-2 gap-6 p-5">
    {/* <!-- Card --> */}
 <NavLink to="https://www.youtube.com/watch?v=QVloM9fOGoU">   <a class="group sm:flex rounded-xl dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600" href="https://www.youtube.com/watch?v=QVloM9fOGoU">
      <div class="flex-shrink-0 relative rounded-xl overflow-hidden w-full h-[200px] sm:w-[250px] sm:h-[350px]">
        <img class="w-full h-full absolute top-0 start-0 object-cover" src={manuments} alt="Image Description"/>
      </div>

      <div class="grow">
        <div class="p-4 flex flex-col h-full sm:p-6">
          <div class="mb-3">
            <p class="inline-flex items-center gap-1.5 py-1.5 px-3 rounded-md text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200">
              Documentry
            </p>
          </div>
          <h3 class="text-lg sm:text-2xl font-semibold text-purple-600 group-hover:text-blue-600 dark:text-gray-300 dark:group-hover:text-white">
          BTS Monuments: Beyond the Star
          </h3>
          <div className='border-2 p-2 border-gray-600 hover:border-purple-400 rounded-lg mb-5 mt-3'>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Genres: </span>Documentary Series
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Release Date: </span>December 20, 2023
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md '>Episode: </span>8
          </p>
          </div>
        </div>
      </div>      
    </a> </NavLink>
    {/* <!-- End Card --> */}
  </div>

  <hr class="border-purple-500 mt-5"></hr>

  <div>
    <div className='flex justify-center'>
       <h1 className='font-bold text-2xl p-2 text-blue-500'>About the show</h1>
    </div>
    <div className='p-5 text-lg font-semibold text-gray-500'>
        <p>On July 12, 2022 KST, Disney and HYBE announced a global content collaboration to showcase a documentary series titled 'BTS Monuments: Beyond the Star.'' A new poster and video teaser was released on November 21, 2023 with episodes to be released beginning on December 20, 2023 on Disney+.</p>
    </div>
    <div className='p-5 text-lg font-semibold text-gray-500'>
        <p>The docu-series will feature music and video footage of the BTS over their 10 year career (including solo projects) and will also look at their daily lives and thoughts as they plan for their next chapter. </p>
    </div>
    <div className='p-5 text-lg font-semibold text-gray-500'>
        <p>Prior to the release of this documentary series, 'PERMISSION TO DANCE ON STAGE in LA' and 'IN THE SOOP: FRIENDCATION' were released as part of the DISNEY x HYBE collaboration.</p>
    </div>
    <div className='text-2xl font-bold text-blue-500 p-4'>
    EPISODES
    </div>
    <div className='text-purple-500 text-xl font-semibold p-1 ml-7'>
        <p>Dec 20, 2023: Ep 1 & 2 at 12 am PT/3am ET</p>
<p>Dec 27, 2023: Ep 3 & 4 at 12 am PT/3am ET</p>
<p>Jan 3, 2024:   Ep 5 & 6 at 12 am PT/3am ET</p>
<p>Jan 10, 2024: Ep 7 & 8 at 12 am PT/3am ET</p>
    </div>
  </div>
        </div>
    </div>
  )
}

export default Varietydetails
